import { useMutation } from '@tanstack/react-query';
import { aivaApi } from 'src/services/api';
import { useCallListClient } from './useGetCallList';

type CallBulkProcessPayload = {
  callIds: string[];
  processed: boolean;
};

export const useCallBulkProcess = () => {
  const { invalidate } = useCallListClient();
  return useMutation({
    mutationFn: ({ callIds, processed }: CallBulkProcessPayload) => {
      return aivaApi.put(`/call/bulk/mark-processed`, {
        call_ids: callIds,
        processed,
      });
    },
    onSuccess: () => {
      invalidate();
    },
  });
};

type CallBulkArchivePayload = {
  callIds: string[];
};

export const useCallBulkArchive = () => {
  const { invalidate } = useCallListClient();
  return useMutation({
    mutationFn: ({ callIds }: CallBulkArchivePayload) => {
      return aivaApi.put(`/call/bulk/delete`, {
        call_ids: callIds,
      });
    },
    onSuccess: () => {
      invalidate();
    },
  });
};

type CallBulkReadPayload = {
  callIds: string[];
  isRead: boolean;
};

export const useCallBulkRead = () => {
  const { invalidate } = useCallListClient();
  return useMutation({
    mutationFn: ({ callIds, isRead }: CallBulkReadPayload) => {
      return aivaApi.put(`/call/bulk/read`, {
        call_ids: callIds,
        is_read: isRead,
      });
    },
    onSuccess: () => {
      invalidate();
    },
  });
};
